// import Auth0ProviderWithHistory from 'auth/Auth0ProviderWithHistory';
import { useEffect, useRef, useState } from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { useClientServiceContext } from 'services/clientServiceProvider';
import { setUserProfile } from 'services/clientServices/slice';

import { useAuth0 } from '@auth0/auth0-react';

import AgentHelp from 'components/AgentHelp';
import AgentPurlBannerFull from 'components/AgentPurlBannerFull';
import AgentPurlBannerThin from 'components/AgentPurlBannerThin';
import BypassLink from 'components/BypassLink';
import Content from 'components/Content';
import Footer from 'components/Footer';
import GoogleTagManager from 'components/GoogleTagManager';
import Header from 'components/Header';
import PlanEnrollBanner from 'components/PlanEnrollBanner';
import PreferredAgentModal from 'components/PreferredAgent';
import {
    setAgentPurlCode,
    setCheckPreferredAgentModal,
    setIsAgentAssociationCompleted
} from 'components/PreferredAgent/slice';
import { setDoctorNames } from 'components/YourDoctorModal/slice';
import { setSelectedMedicaidOption } from 'components/YourMedicaidModal/slice';
import { setPharmacyNames } from 'components/YourPharmacyModal/slice';
import useAuthentication from 'components/hooks/useAuthentication';
import useFetch from 'components/hooks/useFetch';
import useQueryParams from 'components/hooks/useQueryParams';

import bypassContext from 'contexts/bypass';
import hamburgerContext from 'contexts/hamburger';
import phoneContext from 'contexts/phone';
import prescriptionModalContext from 'contexts/prescriptionModal';
import purlAgentContext from 'contexts/purlAgentContext';
import ZipCodeContext from 'contexts/zipCode';

import { getProvidersSearchLookUp } from 'utilities/apiSession';
import {
    AUTHENTICATED_ROUTES,
    AVAILABLE_AGENTS_ROUTE,
    CONTACT_AN_AGENT_ROUTE,
    VERIFY_EMAIL_ROUTE
} from 'utilities/routes';
import scrollToTop from 'utilities/scrollToTop';
import { PURL_AGENT_CODE, PURL_AGENT_DATA } from 'utilities/sessionStorageKeys';
import {
    COUNTIES_KEY,
    COUNTY_FIPS_KEY,
    LEAD_ID_KEY,
    PHARMACY_LIST_PAGE,
    ZIP_CODE_KEY,
    STATE_KEY,
    MEDICAID_KEY
} from 'utilities/storageKeys';
import { validateZipCode } from 'utilities/validate';

import { getPhoneData } from './data';

import styles from './styles.module.scss';

import { setDrugNames } from 'temp/components/YourPrescriptionModal/slice';
import { countySearch } from 'temp/utilities/apiSearch';
import {
    getPrescriptions,
    getPharmacies,
    getPurlAgentData
} from 'temp/utilities/apiSession';
import { getPlanCounts } from 'temp/utilities/apiSession/plans';
import { checkModalDataHasChanged } from 'temp/utilities/modalHelper';
import { get, set, remove } from 'temp/utilities/storage';

const PURL_URL_PARAM = 'purl';

const MainLayout = () => {
    const location = useLocation();

    const [contentId, setContentId] = useState(
        bypassContext._currentValue.contentId
    );
    const [phone, setPhone] = useState('');
    const [prescriptionModal, setPrescriptionModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [zipCode, setZipCode] = useState(get(ZIP_CODE_KEY, ''));
    const [counties, setCounties] = useState(get(COUNTIES_KEY, []));
    const [county, setCounty] = useState(get(COUNTY_FIPS_KEY, ''));
    const [state, setState] = useState(get(STATE_KEY, ''));
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [continueButtonDisabled, setContinueButtonDisabled] = useState(true);
    const [purlAgentCode, setPurlAgentCode] = useState(null);
    const [purlAgentData, setPurlAgentData] = useState(null);
    const [error, setError] = useState(false);
    const firstUpdate = useRef(true);
    const queryParams = useQueryParams();
    const { clientService } = useClientServiceContext();
    const [carrierCount, setCarrierCount] = useState(78);
    const [planCount, setPlanCount] = useState(2613);

    const isAgentAssociationCompleted = useSelector(
        state => state.preferredAgentDetails.isAgentAssociationCompleted
    );

    const checkPreferredAgentModal = useSelector(
        state => state.preferredAgentDetails.checkPreferredAgentModal
    );

    const initialDrugNames = useSelector(
        state => state.prescriptionDetails.drugNames
    );
    const initialDoctorsNames = useSelector(
        state => state.doctorDetails.doctorNames
    );
    const initialPharmacyNames = useSelector(
        state => state.pharmacyDetails.pharmacyNames
    );
    const userProfile = useSelector(state => state.userProfile.userProfile);

    const agentPurlCode = useSelector(
        state => state.preferredAgentDetails.agentPurlCode
    );

    const { Put: updateAccountData } = useFetch(
        `${process.env.REACT_APP_ACCOUNT_SERVICE_URL}/Update`
    );

    const history = useHistory();
    if (
        queryParams.get('error') &&
        queryParams.get('error_description') &&
        queryParams
            .get('error_description')
            .indexOf('Please verify your email address') !== -1
    ) {
        var errorDescription = queryParams.get('error_description');
        var userIdIndex = queryParams
            .get('error_description')
            .indexOf('UserId');
        var emailAddress = errorDescription.substring(
            errorDescription.indexOf('Email') + 7,
            userIdIndex - 1
        );
        var auth0UserId = errorDescription.substring(
            errorDescription.indexOf('UserId') + 8
        );
        localStorage.setItem('verifyEmail', emailAddress);
        localStorage.setItem('verifyEmailUserId', auth0UserId);
        // auth0UserId = auth0UserId.substring(6);
        history.push(VERIFY_EMAIL_ROUTE, {
            email: emailAddress,
            userId: auth0UserId
        });
    }

    const {
        consumerId,
        email,
        firstName,
        hasMedicAid,
        lastName,
        leadIdGuid,
        mbi,
        mbiFirstName,
        mbiLastName,
        partAEffectiveDate,
        partBEffectiveDate,
        phoneNumber,
        userId
    } = userProfile;

    const dispatch = useDispatch();

    const { isAuthenticated, user } = useAuth0();

    const fetchPurlAgentDetails = useCallback(async newAgentCode => {
        const response = await getPurlAgentData();
        if (response) {
            set(PURL_AGENT_DATA, response);
            setPurlAgentData(response);
            setPurlAgentCode(newAgentCode);
        } else {
            remove(PURL_AGENT_DATA);
        }
        return response;
    }, []);

    useAuthentication();

    useEffect(() => {
        scrollToTop();
    }, [location]);

    const getCounties = async zipCode => {
        setButtonDisabled(true);
        setError(false);

        let allCounties = await countySearch({ zipCode }).catch(error =>
            console.log(error)
        );
        onSetCounties(allCounties);

        if (!allCounties) {
            setError(true);
        }

        if (allCounties?.length) {
            setButtonDisabled(false);
            setContinueButtonDisabled(false);
            if (allCounties?.length === 1)
                onSetCounty(allCounties[0]?.countyFIPS);
        }

        allCounties && onSetState(allCounties[0]?.state);

        return allCounties;
    };

    useEffect(() => {
        if (
            isAuthenticated &&
            purlAgentData &&
            !isAgentAssociationCompleted &&
            agentPurlCode &&
            !localStorage.getItem('reqAgentData')
        ) {
            dispatch(setCheckPreferredAgentModal(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentPurlCode,
        purlAgentData,
        isAuthenticated,
        isAgentAssociationCompleted
    ]);

    const onZipCodeChange = async () => {
        const payload = {
            consumerId,
            county: county,
            email,
            firstName,
            hasMedicAid,
            inactive: 0,
            lastName,
            leadIdGuid,
            mbi,
            mbiFirstName,
            mbiLastName,
            partAEffectiveDate,
            partBEffectiveDate,
            phoneNumber,
            userId,
            zip: zipCode
        };

        if (firstUpdate.current) {
            firstUpdate.current = false;
            if (validateZipCode(zipCode) && county && counties?.length) {
                setButtonDisabled(false);
                setContinueButtonDisabled(false);
                if (isAuthenticated && consumerId) {
                    await updateAccountData(payload);
                }
                return;
            }
        }
        setContinueButtonDisabled(true);
        if (validateZipCode(zipCode)) {
            setContinueButtonDisabled(false);
            if (isAuthenticated && consumerId) {
                await updateAccountData(payload);
            }
            onSetCounties(await getCounties(zipCode));
        } else {
            if (zipCode.length) setError(true);
        }
    };

    const fetchPlanCounts = async () => {
        const result = await getPlanCounts({ Zip: zipCode, Fips: county });
        setCarrierCount(result.carrierCount);
        setPlanCount(result.planCount);
    };

    useEffect(() => {
        onZipCodeChange();
        // this effect should only be rerun when the zip code changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCode]);

    useEffect(() => {
        if (zipCode && county) fetchPlanCounts();
        // this effect should only be rerun when the zip code changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCode, county]);

    const Onload = useCallback(
        async userProfile => {
            const { consumerid } = userProfile || {};
            const response =
                consumerid &&
                (await clientService
                    .getConsumerByConsumerId(consumerid)
                    .catch(error => console.error(error)));
            const { purl, leadIdGuid, zip, county, hasMedicAid } =
                response || {};

            if (response?.agentNPN) {
                if (purl) {
                    set(PURL_AGENT_CODE, purl);
                    fetchPurlAgentDetails(purl);
                }
            }
            dispatch(setUserProfile(response));
            set(LEAD_ID_KEY, leadIdGuid);
            if (zip) {
                set(ZIP_CODE_KEY, zip);
                setZipCode(zip);
            }
            if (county) {
                set(COUNTY_FIPS_KEY, county);
                setCounty(county);
            }

            if (hasMedicAid === 1) {
                set(MEDICAID_KEY, 'Yes');
                dispatch(setSelectedMedicaidOption('Yes'));
            } else if (hasMedicAid === 0) {
                set(MEDICAID_KEY, 'No');
                dispatch(setSelectedMedicaidOption('No'));
            } else if (hasMedicAid === 2) {
                set(MEDICAID_KEY, 'I’m not sure');
                dispatch(setSelectedMedicaidOption('I’m not sure'));
            }

            const data = await getProvidersSearchLookUp();
            const providers = data?.providers ?? [];
            const doctorNames = providers.map(item => {
                const { presentationName, NPI } = item;

                return { presentationName, NPI };
            }, []);

            if (checkModalDataHasChanged(initialDoctorsNames, doctorNames)) {
                dispatch(setDoctorNames(doctorNames || []));
            }

            const pharmacies = await getPharmacies();
            const pharmacyNames = pharmacies?.map(item => item.name);

            if (checkModalDataHasChanged(initialPharmacyNames, pharmacyNames)) {
                dispatch(setPharmacyNames(pharmacyNames || []));
            }

            pharmacyNames
                ? set(PHARMACY_LIST_PAGE, true)
                : set(PHARMACY_LIST_PAGE, false);

            const prescriptions = await getPrescriptions();

            const drugNames = prescriptions.map(item => {
                const { drugName, labelName } = item?.dosage;

                return {
                    drugName,
                    labelName
                };
            });

            if (checkModalDataHasChanged(initialDrugNames, drugNames)) {
                dispatch(setDrugNames(drugNames));
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            dispatch,
            initialDoctorsNames,
            initialDrugNames,
            initialPharmacyNames,
            fetchPurlAgentDetails
        ]
    );

    useEffect(() => {
        if ((isAuthenticated && user) || isAgentAssociationCompleted) {
            Onload(user);
        }
    }, [isAuthenticated, user, Onload, isAgentAssociationCompleted]);

    useEffect(() => {
        (async () => {
            const phoneData = await getPhoneData();

            if (phoneData?.length) {
                setPhone(phoneData[0]);
            }
        })();
    }, []);

    useEffect(() => {
        const pURLCode = get(PURL_AGENT_CODE);
        if (pURLCode?.length > 0) {
            var uri = new URL(window.location.href);
            if (!uri.searchParams.get('purl')) {
                uri.searchParams.append('purl', pURLCode);
                if (uri.hash) {
                    window.history.replaceState(
                        null,
                        null,
                        `?${uri.searchParams}${uri.hash}`
                    );
                } else {
                    window.history.replaceState(
                        null,
                        null,
                        `?${uri.searchParams}`
                    );
                }
            }
        }
    }, [fetchPurlAgentDetails, history, location]);

    useEffect(() => {
        const newPurlAgentCode = queryParams.get(PURL_URL_PARAM);
        if (get(PURL_AGENT_DATA)) {
            setPurlAgentData(get(PURL_AGENT_DATA));
            setPurlAgentCode(get(PURL_AGENT_CODE));
        }
        if (newPurlAgentCode) {
            set(PURL_AGENT_CODE, newPurlAgentCode);
            fetchPurlAgentDetails(newPurlAgentCode);
            dispatch(setAgentPurlCode(newPurlAgentCode));
            dispatch(setIsAgentAssociationCompleted(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setPurlAgentContext = (code, data) => {
        setPurlAgentCode(code);
        setPurlAgentData(data);
    };

    const onSetCounties = newCounties => {
        set(COUNTIES_KEY, newCounties);
        setCounties(newCounties);
    };

    const onSetCounty = newCounty => {
        set(COUNTY_FIPS_KEY, newCounty);
        setCounty(newCounty);
    };

    const onSetState = newState => {
        set(STATE_KEY, newState);
        setState(newState);
    };

    const onSetZipCode = zip => {
        if (zipCode !== zip) {
            onSetCounties([]);
            onSetCounty('');
            onSetState('');
            setZipCode(zip.replace(/\D/g, ''));
            set(ZIP_CODE_KEY, zip.replace(/\D/g, ''));
        }
    };

    const isHomePage = window.location.pathname === '/';
    const isAvailableAgentsPage =
        window.location.pathname === AVAILABLE_AGENTS_ROUTE;

    const href = window.location.href;
    useEffect(() => {
        if (
            window.location.pathname !== CONTACT_AN_AGENT_ROUTE &&
            window.location.href.indexOf('?purl=') === -1
        ) {
            localStorage.removeItem('clearFilterSearch');
        }
    }, [href]);

    if (AUTHENTICATED_ROUTES.includes(location.pathname) && !isAuthenticated) {
        return null;
    }

    return (
        <ZipCodeContext.Provider
            value={{
                buttonDisabled,
                counties,
                county,
                error,
                setButtonDisabled,
                setCounties: onSetCounties,
                setCounty: onSetCounty,
                setError,
                setZipCode: onSetZipCode,
                zipCode,
                setState: onSetState,
                state,
                continueButtonDisabled,
                setContinueButtonDisabled,
                onZipCodeChange,
                carrierCount,
                planCount
            }}
        >
            <bypassContext.Provider value={{ contentId, setContentId }}>
                <hamburgerContext.Provider value={{ isOpen, setIsOpen }}>
                    <phoneContext.Provider value={{ phone, setPhone }}>
                        <prescriptionModalContext.Provider
                            value={{
                                prescriptionModal,
                                setPrescriptionModal
                            }}
                        >
                            <purlAgentContext.Provider
                                value={{
                                    purlAgentCode,
                                    purlAgentData,
                                    setPurlAgentContext,
                                    fetchPurlAgentDetails
                                }}
                            >
                                <div className={styles.mainLayout}>
                                    <GoogleTagManager id="GTM-T9PSFB6" />

                                    <BypassLink contentId={contentId} />
                                    {isHomePage ? (
                                        <AgentPurlBannerFull />
                                    ) : (
                                        <AgentPurlBannerThin />
                                    )}
                                    <Header
                                        shouldHideNavigation={
                                            isAvailableAgentsPage
                                        }
                                    />
                                    <PlanEnrollBanner />

                                    <Content />

                                    {checkPreferredAgentModal ? (
                                        <PreferredAgentModal />
                                    ) : null}

                                    <Footer
                                        className={styles.footer}
                                        shouldHideLinks={isAvailableAgentsPage}
                                    />
                                    {!isAvailableAgentsPage && <AgentHelp />}
                                </div>
                            </purlAgentContext.Provider>
                        </prescriptionModalContext.Provider>
                    </phoneContext.Provider>
                </hamburgerContext.Provider>
            </bypassContext.Provider>
        </ZipCodeContext.Provider>
    );
};

export default MainLayout;
